//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.AECDesign.js";
import "../Features/Features.FeatureBuilder.js";
import "../no/SelectPointList.js";
import "../Features/Features.AECDesign.LevelReferenceBuilder.js";
import "../Features/Features.AECDesign.MaterialLayersBuilder.js";
import "../no/Expression.js";
import "../no/Section.js";
import "../no/ScCollector.js";
import "../no/Features.js";
import "../no/Expression.js";
import "../no/ScCollector.js";
import "../no/Section.js";
import "../no/SelectObjectList.js";
let d=[[[0,"Alignment",1,0],[1,"AlternateSolutionPoint",0,"SelectPointList",0],[0,"BooleanType",1,0],[1,"LevelReferenceBottom",0,"Features.AECDesign.LevelReferenceBuilder",0],[1,"LevelReferenceTop",0,"Features.AECDesign.LevelReferenceBuilder",0],[1,"MaterialLayers",0,"Features.AECDesign.MaterialLayersBuilder",0],[1,"Offset",0,"Expression",0],[0,"ReverseOffsetDirection",1,0],[1,"Section",0,"Section",0],[1,"SelectedBodies",0,"ScCollector",0],[0,"Split",1,0]],[],[]];
SPLM.Features.AECDesign.WallBuilder = class extends SPLM.Features.FeatureBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.AECDesign.WallBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.AECDesign.WallBuilder.AlignmentOption = Object.freeze({
    "Exterior" : "Exterior", "Interior" : "Interior", "Centerline" : "Centerline"});

SPLM.Features.AECDesign.WallBuilder.BooleanOption = Object.freeze({
    "None" : "None", "Unite" : "Unite", "Trim" : "Trim"});

export default SPLM;